import { Component, OnInit } from '@angular/core';
import { SnackBarService, SnackBar } from '../../services/snack-bar.service';

@Component({
    selector: 'snack-bar',
    templateUrl: 'snack-bar.component.html',
    standalone: false
})
export class SnackBarComponent implements OnInit {
  snackBars: SnackBar[] = [];

  constructor(private SnackBarService: SnackBarService) {}

  ngOnInit() {
    this.SnackBarService.getSnackBar().subscribe((snackBar: SnackBar) => {
      if (!snackBar) {
        this.snackBars = [];
        return;
      }
      this.snackBars.push(snackBar);
      setTimeout(() => this.removeSnackBar(snackBar), snackBar.duration * 1000);
    });
  }

  removeSnackBar(SnackBar: SnackBar) {
    this.snackBars = this.snackBars.filter((x) => x !== SnackBar);
  }
}
